import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { c as cx } from './index-tZvMCc77.js';

import './Spinner-B55mSnmk.css';const Spinner$1 = "_Spinner_qr6ci_3";
const Inherit = "_Inherit_qr6ci_22";
const circle = "_circle_qr6ci_25";
const styles = {
	Spinner: Spinner$1,
	Inherit: Inherit,
	circle: circle};

const Spinner = forwardRef(
  (props, ref) => {
    const { className, inherit, ...rest } = props;
    const classNames = cx(styles["Spinner"], className, {
      [styles["Inherit"]]: inherit
    });
    return /* @__PURE__ */ jsx("span", { "data-anv": "spinner", className: classNames, ref, children: /* @__PURE__ */ jsx("span", { className: styles["circle"], ...rest }) });
  }
);
Spinner.displayName = "Spinner";

export { Spinner as S };
//# sourceMappingURL=Spinner-B55mSnmk-B3oOSVLo.js.map
